import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hotTags, comics } from "../../../mocks/manga";

const heroBg = "https://readdy.ai/api/search-image?query=vibrant%20stylized%20anime%20illustration%20of%20a%20cozy%20reading%20corner%20with%20stacked%20manga%20and%20floating%20glowing%20covers%2C%20warm%20coral%20and%20amber%20palette%2C%20magical%20sparkles%20and%20soft%20bokeh%2C%20energetic%20fantasy%20reading%20atmosphere%2C%20clean%20minimal%20composition%2C%20high%20detail%20digital%20painting&width=1600&height=900&seq=hero-yaojing-2026&orientation=landscape";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const featured = comics.slice(0, 3);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/library?keyword=${encodeURIComponent(keyword.trim())}`);
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="妖精漫画网 漫画阅读收藏主题背景" className="h-full w-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 pb-20 pt-16 text-center md:px-6 md:pb-28 md:pt-24">
        <p className="mb-5 flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-sparkling-2-fill text-accent-300" aria-hidden="true"></i>
          阅读 · 收藏 · 书单 · 标签 · 目录整理
        </p>

        <h1 className="font-display text-4xl leading-tight text-background-50 md:text-6xl">
          把喜欢的漫画
          <span className="text-accent-400">统一收藏</span>
          ，随时接着看
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          妖精漫画网提供漫画阅读、收藏、下载、书单与标签整理功能，帮你管理所有作品，按标签筛选、追更找漫更省心，阅读体验更顺手。
        </p>

        <form onSubmit={handleSearch} role="search" className="mt-8 w-full max-w-xl">
          <div className="flex items-center gap-2 rounded-full bg-background-50 p-1.5 shadow-none">
            <i className="ri-search-line pl-4 text-lg text-foreground-500" aria-hidden="true"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索想看的漫画、作者或标签"
              aria-label="搜索漫画"
              className="w-full bg-transparent px-2 py-2 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
            <button type="submit" className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
              开始找漫
            </button>
          </div>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-200">热门：</span>
          {hotTags.slice(0, 6).map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => navigate(`/library?tag=${encodeURIComponent(tag)}`)}
              className="whitespace-nowrap rounded-full border border-background-50/25 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-accent-500 hover:text-foreground-950"
            >
              #{tag}
            </button>
          ))}
        </div>
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-5 px-4 pb-14 sm:grid-cols-3 md:px-6">
        {featured.map((comic, idx) => (
          <button
            key={comic.id}
            type="button"
            onClick={() => navigate(`/detail/${comic.id}`)}
            className={`group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50/95 p-3 text-left backdrop-blur-md transition-transform hover:-translate-y-1 ${idx === 1 ? "sm:-translate-y-4 sm:hover:-translate-y-6" : ""}`}
            aria-label={`查看推荐漫画《${comic.title}》`}
          >
            <img src={comic.cover} alt={`${comic.title} 推荐封面`} className="h-28 w-20 shrink-0 rounded-xl object-cover object-top" />
            <div className="min-w-0">
              <span className="flex items-center gap-1 text-xs font-bold text-primary-600">
                <i className="ri-fire-fill" aria-hidden="true"></i> 本周热门
              </span>
              <h3 className="mt-1 truncate font-display text-lg text-foreground-950">{comic.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{comic.author} · {comic.chapters}话</p>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {comic.tags.slice(0, 2).map((t) => (
                  <span key={t} className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-600">#{t}</span>
                ))}
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}